import controller from './chart-differential-pressure.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};
